import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=54225718&scoped=true"
import script from "./Cart.js?vue&type=script&lang=js&external"
export * from "./Cart.js?vue&type=script&lang=js&external"
import style0 from "./Cart.scss?vue&type=style&index=0&id=54225718&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54225718",
  null
  
)

export default component.exports